// removed by extract-text-webpack-plugin
module.exports = {"bannerCarouselWrap":"qempo_BannerCarousel_bannerCarouselWrap-2fwgoXe","textInformationImage":"qempo_BannerCarousel_textInformationImage-1dNvPbc","button":"qempo_BannerCarousel_button-1nc-07L","dots":"qempo_BannerCarousel_dots-ExSeyGb","qempoFlash":"qempo_BannerCarousel_qempoFlash-x8IA7fj","textIphone14":"qempo_BannerCarousel_textIphone14-1MXCDP4","textIphone15":"qempo_BannerCarousel_textIphone15-8Lob25T","textIphone16":"qempo_BannerCarousel_textIphone16-2kOXjZw","blackFriday":"qempo_BannerCarousel_blackFriday-3uNQUek","appleProducts":"qempo_BannerCarousel_appleProducts-nByhhCx"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/elements/BannerCarousel/BannerCarousel.scss
// module id = 2261
// module chunks = 0